import React from 'react';
import { Box, Modal } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { useStore } from '../../stores/store';

export default observer(function ModalContainer() {
  const { modalStore } = useStore();
  const { modal: { open, body }, closeModal } = modalStore;

  const modalbody = (
    <div>
      {body}
    </div>
  );
  return (
    <Box sx={{ maxWidth: 800 }}>
      <Modal
        open={open}
        onClose={closeModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box>
          {modalbody}
        </Box>
      </Modal>
    </Box>
  );
})